import { useCallback, useState } from 'react';
import useCurrentClientLocation from '~/client/hooks/geo/useCurrentClientLocation';
import useDidMount from '~/client/hooks/lifecycle/useDidMount';

const useUserGeoLocation = () => {
  const { getCurrentClientLocation } = useCurrentClientLocation();
  const [userGeoCountryCode, setUserGeoCountryCode] = useState('');

  const getUserGeoLocation = useCallback(async () => {
    const { data } = await getCurrentClientLocation({});
    const countryCode =
      data?.geolocationGetCurrentClientLocation?.country?.countryCode;
    setUserGeoCountryCode(countryCode ?? '');
  }, [getCurrentClientLocation]);

  useDidMount(() => {
    getUserGeoLocation();
  });

  return { userGeoCountryCode, setUserGeoCountryCode };
};

export default useUserGeoLocation;
